"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDispatchOver = exports.isAsapMission = exports.isSingleDate = exports.describeTrips = exports.describeMission = exports.computeTripCountFromPassengers = void 0;
var moment_1 = __importDefault(require("@ambler/moment"));
var misc_1 = require("../misc");
var utils_1 = require("../utils");
var computeTripCountFromPassengers = function (passengers) {
    return passengers
        .map(function (p) { return ["".concat(p.origin.id, "-").concat(p.departureTime), "".concat(p.destination.id, "-").concat(p.arrivalTime)]; })
        .filter(function (_a, index, arr) {
        var origin = _a[0];
        return arr.findIndex(function (_a) {
            var origin_ = _a[0];
            return origin_ === origin;
        }) === index;
    })
        .filter(function (_a, index, arr) {
        var dest = _a[1];
        return arr.findIndex(function (_a) {
            var dest_ = _a[1];
            return dest_ === dest;
        }) === index;
    }).length;
};
exports.computeTripCountFromPassengers = computeTripCountFromPassengers;
var describeMission = function (mission) {
    var passengers = mission.trips.flatMap(function (trip) { return trip.passengers; });
    return (0, exports.describeTrips)(passengers);
};
exports.describeMission = describeMission;
var describeTrips = function (passengers) {
    // * If every passenger and otherPassenger are dispatched to the same mission.
    // * So we have to talk about round trip and not just trip.
    if (passengers.every(function (passenger) { return passenger.otherPassenger; })) {
        var tripCount_1 = (0, exports.computeTripCountFromPassengers)(passengers.filter(function (p) { return p.direction === 'OUTBOUND'; }));
        return {
            tripCount: tripCount_1,
            isRoundTrip: true,
        };
    }
    // * Not every passenger and otherPassenger are dispatched to the same mission.
    // * So we have to talk about trip and not round trip.
    var tripCount = (0, exports.computeTripCountFromPassengers)(passengers);
    return {
        tripCount: tripCount,
        isRoundTrip: false,
    };
};
exports.describeTrips = describeTrips;
var isSingleDate = function (trips) {
    var firstDate = (0, moment_1.default)(trips[0].departureTime).format('YYYY-MM-DD');
    return trips.every(function (_a) {
        var departureTime = _a.departureTime;
        return (0, moment_1.default)(departureTime).format('YYYY-MM-DD') === firstDate;
    });
};
exports.isSingleDate = isSingleDate;
var isAsapMission = function (mission) {
    var _a = mission.trips[0].passengers[0], timeReference = _a.timeReference, direction = _a.direction;
    return timeReference === 'UNKNOWN' && direction === 'OUTBOUND';
};
exports.isAsapMission = isAsapMission;
var isDispatchOver = function (missionStatus) {
    return (missionStatus &&
        !(0, utils_1.isIn)(__spreadArray(__spreadArray(['CREATED', 'EDITED', 'WAIT_DISPATCH_STATUS'], misc_1.dispatchStatuses, true), ['PREBOOKED', 'DELAYED'], false), missionStatus));
};
exports.isDispatchOver = isDispatchOver;
//# sourceMappingURL=mission.js.map